<template>
  <div class="page dataList">
    <div class="p16">
      <p style="font-weight: bold;">套餐卡交易数据<span class="moneys fontSize14">（数据指标可能存在几分钟延迟）</span></p>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs mb10 br10">
            <div class="titles">
              <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>套餐数据</i></p>
              <v-date @time="change" class="ml10"></v-date>
            </div>
            <el-row class="rows">
              <el-col class="cols" :span="6">
                <p class="van-text van-ellipsi text">购买金额（会员卡）</p>
              <p class="van-label f16">{{amount.cardSaleAmountWallet}}</p>
              </el-col>
              <el-col class="cols" :span="6">
                <p class="van-text van-ellipsi text">购买金额（现金）</p>
              <p class="van-label f16">{{amount.cardSaleAmountCash}}</p>
              </el-col>
              <el-col class="cols" :span="6">
                <p class="van-text">划卡消费金额</p>
              <p class="van-label f16">{{amount.cardUseConsumeAmount}}</p>
              </el-col>
              <el-col class="cols" :span="6">
                <p class="van-text">套餐购买提成</p>
                <p class="van-label f16">{{amount.cardSaleDeductAmount}}</p>
              </el-col>
              <el-col class="cols" :span="6">
                <p class="van-text">套餐购买社保补贴</p>
                <p class="van-label f16">{{amount.cardSocialSubsidyAmount}}</p>
              </el-col>
              <el-col class="cols" :span="6">
                <p class="van-text">套餐划卡提成</p>
                <p class="van-label f16">{{amount.cardUseDeductAmount}}</p>
              </el-col>
              <el-col class="cols" :span="6">
                <p class="van-text">套餐划卡社保补贴</p>
                <p class="van-label f16">{{amount.cardUseSocialSubsidyAmount}}</p>
              </el-col>
              <el-col class="cols" :span="6">
                <p class="van-text">开卡总数</p>
              <p class="van-label f16">{{amount.cardSaleTotal}}</p>
              </el-col>
              <el-col class="cols" :span="6">
                <p class="van-text">划卡总数</p>
              <p class="van-label f16">{{amount.cardUseTotal}}</p>
              </el-col>
            </el-row>
          </div>
          <div class="boxs br10">
            <div class="align-items pr16" @click="lookList">
              <div class="titles">
                <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>划卡明细</i></p>
              </div>
              <p ><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
            </div>
            <div class="plr16" v-if="listFlag">
              <el-table :data="list" :max-height="height - 580" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="cardName" label="卡类型" width="auto"></el-table-column>
                <el-table-column prop="tradeNum" label="划卡次数" width="auto"></el-table-column>
                <el-table-column label="订单时间" width="auto">
                  <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
                </el-table-column>
              </el-table>
              <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  mixins: [minxin],
  data() {
    return {
      dataUrl: require("../../../assets/images/home/data.png"),
      amount: {
        itemName: "",
        itemNum: "",
        saleAmount: "", //销售业绩
        saleDeductAmount: "",
        workAmount: "", //劳动
        workDeductAmount: "",
        cardSocialSubsidyAmount: "",
        cardUseConsumeAmount: "",
      },
      list: [],
      query: {
        beginTime: new Date(),
        endTime: new Date()
      },
      url: this.$url.report.list,
      listFlag: false,
      height: this.$store.getters.MainHeight,
      totalCount: 0
    };
  },

  created() {
    // this.init();
    // this.getList();
  },
  methods: {
    back() {
      this.$router.push('/dataList');
    },
    change(value) {
      this.query.start = 1;
      this.totalCount = 0;
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      this.listFlag = false;
      this.list = [];
      this.init();
    },
    init(val) {
      this.$api.post(this.$url.report.sum, {
        beginTime: this.query.beginTime,
        endTime: this.query.endTime
      }).then(res => {
        if (res) {
          this.amount = res;
        }
      });
    },
    totalCounts () {
      
      this.$api.post(this.$url.report.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    lookList () {
      // 查看列表
      if (!this.listFlag) {
        this.totalCounts();
        this.listFlag = true;
      }
    },
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.page-head {
  height: 100%;
}
</style>